const { createContext } = require("react");

export const ProductsContext = createContext('context created');